export default __webpack_public_path__ + "static/media/enfem1.477de136.jpeg";